import { z } from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ThemeSwitch } from '@/components/theme-switch'
import { AuthButton } from '@/features/auth/index'
import { Chat } from '@/features/chats'
import { TransactionsDialog } from '@/features/transactions'

// 定义搜索参数 Schema（预留用于未来扩展）
const chatSearchSchema = z.object({})

export const Route = createFileRoute('/_authenticated/chats/$sessionId')({
  component: ChatPage,
  validateSearch: chatSearchSchema,
})

export function ChatPage() {
  const { sessionId } = Route.useParams()

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ms-auto flex items-center space-x-4'>
          <ThemeSwitch />
          <TransactionsDialog />
          <AuthButton />
        </div>
      </Header>
      <Main fixed fluid className='mx-0 w-full max-w-none px-0 py-0'>
        <Chat sessionId={sessionId} />
      </Main>
    </>
  )
}
